export function handleToken(token) {
    if (token && token !== "") {
        return Promise.resolve(token);
    }
    return Promise.reject("invalid token");
}
export const publicGet = (url) => {
    return fetchJson(METHOD.GET, url, null, null, null);
};
export const fetchJson = (method, url, headers, body, token) => {
    // console.log('fetchJson token:');
    // console.log(token);
    let opts = {};
    opts.method = method;
    opts.headers = {
        'Content-Type': 'application/json',
    };
    opts.mode = 'cors';
    if (body) {
        opts.body = JSON.stringify(body);
    }
    if (headers)
        opts.headers = headers;
    if (token) {
        opts.headers['Authorization'] = 'Bearer ' + token;
    }
    return fetch(url, opts)
        .then(handleErrorStatus)
        .then(tryToParseJsonEmptyObjOtherwise)
        .then(json => ({
        data: json
    })).catch(err => {
        console.error('TCARE internal fetch error: ', err);
        // return {errors: [{message: 'Exception thrown while fetching data.'}]};
        return { errors: [{ message: err }] };
    });
};
// this function assumes that the response is valid, needs work.
// we should consider a standard payload i.e. {data:any,errors:Array<Error>}
// todo evaluate what we want to do when we can't parse json
// todo marshalling into expected structure
function tryToParseJsonEmptyObjOtherwise(jres) {
    return jres.res.json().then((json => json), (err => ({})));
}
function handleErrorStatus(response) {
    if (response.status >= 300) {
        if (response.status === 401) {
            return Promise.reject("unauthorized");
        }
        return Promise.reject("error code on fetch");
    }
    return Promise.resolve({ res: response });
    // return {res:response}
}
export function hasErrors(res) {
    return (res === null || res === void 0 ? void 0 : res.errors) ? res.errors.length > 0 : false;
}
//makes JsonResponse feel more like a traditional 'Response object' for purposes of backwards compatability
//deprecated
export function normalized(res) {
    if (hasErrors(res)) {
        return {
            errors: res.errors,
        };
    }
    return res.data;
}
export const METHOD = {
    GET: 'GET',
    POST: 'POST',
    DELETE: 'DELETE',
};
